import core from './core';

export const fetchAuthToken = async (): Promise<string> => {
  const response = await core.get('/api/2/auth/token');

  return response.data.results?.jwt?.jwt_token;
};
